import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import useStore from "../../utils/store";
import Head from "../Head";
import Sidebar from "./Sidebar";

const forbiddenForViewAdmin = [
  "/admin/client/add",
  "/admin/customer/add",
  "/admin/non-verified-customers",
  "/admin/group",
  "/admin/products",
  "/admin/product-gst",
  "/admin/product-price",
  "/admin/staff",
  "/admin/staff/incentive",
  "/admin/trash",
];

const allAdminLinks = [
  {
    title: "Dashboard",
    path: "/admin",
  },
  {
    title: "Staff",
    path: "/admin/staff",
  },
  {
    title: "Staff Incentive",
    path: "/admin/staff/incentive",
  },
  {
    title: " Trader",
    path: "/admin/client",
  },
  {
    title: " Trader ADD",
    path: "/admin/client/add",
  },
  {
    title: "Products",
    path: "/admin/products",
  },
  {
    title: "Customer ADD",
    path: "/admin/customer/add",
  },
  {
    title: "Customer",
    path: "/admin/customer",
  },
  {
    title: "Non-Verified Customer",
    path: "/admin/non-verified-customers",
  },
  {
    title: "City ADD",
    path: "/admin/group",
  },
  {
    title: "Dispatch ",
    path: "/admin/dispatch/complete",
  },
  {
    title: "Dispatch Completed",
    path: "/admin/dispatch",
  },
  {
    title: "Orders",
    path: "/admin/orders",
  },
  {
    title: "Payments",
    path: "/admin/payments",
  },
  {
    title: "Purchase",
    path: "/admin/purchase",
  },
  {
    title: "Stock",
    path: "/admin/non-woven-stock",
  },
  {
    title: "Product Price ADD",
    path: "/admin/product-price",
  },
  {
    title: "Customer Calling",
    path: "/admin/customer/group",
  },
  {
    title: "Invoices",
    path: "/admin/invoice",
  },
  {
    title: "Contact",
    path: "/admin/contact",
  },
  {
    title: "Trash Bin",
    path: "/admin/trash",
  },
  {
    title: "Logout",
    path: "/logout",
  },
];

const Layout = ({ children, onClick, text, title, reload, hideDatePicker }) => {
  const [open, setOpen] = useState(false);
  const user = useStore((state) => state.user);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!user || (user?.type !== "Admin" && user?.type !== "ViewAdmin")) {
      navigate("/login");
      return;
    }
    if (
      user?.type === "ViewAdmin" &&
      forbiddenForViewAdmin.some((p) => location.pathname === p || location.pathname.startsWith(p + "/"))
    ) {
      navigate("/admin");
    }
  }, [user, navigate, location.pathname]);

  const displayedLinks =
    user?.type === "ViewAdmin"
      ? allAdminLinks.filter((l) => !forbiddenForViewAdmin.includes(l.path))
      : allAdminLinks;

  return (
    <div className="md:flex min-h-[100dvh]  bg-layoutbg">
      <Sidebar
        open={open}
        setOpen={setOpen}
        links={displayedLinks}
      />

      <div className="w-full md:overflow-y-auto ">
        <Head
          onClick={onClick}
          text={text}
          title={title ?? user?.admin?.userName ?? user?.staff?.userName ?? user?.userName}
          menu={() => setOpen(true)}
          reload={reload}
          hideDatePicker={hideDatePicker}
        />

        <div className="px-6 py-4  ">{children}</div>
      </div>
    </div>
  );
};

export default Layout;

